import { render, staticRenderFns } from "./TkSvgIcon.vue?vue&type=template&id=7d1d0792&functional=true&"
import script from "./TkSvgIcon.vue?vue&type=script&lang=js&"
export * from "./TkSvgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports